export enum PageEnum {
    GetQuote = "getQuote",
    SelectCover = "selectCover",
    CoverSummary = "coverSummary",
    YourDetails = "yourDetails",
    PaymentDetails = "paymentDetails",
    YourPlan = "yourPlan",
    ConfirmationPage = "confirmationPage",
    ErrorPage = "errorPage",
}
